import { useCallback, useEffect, useState } from "react";
import { FetchAccountFeatures } from "../services/account";
import { useRefreshOnAccountFeaturesUpdated } from "./useRefreshOnAccountFeaturesUpdated";

export const SMART_CAMPAIGN_FEATURE_KEYS = [
  "smart_campaign",
  "smart_campaign_draft",
  "ai_campaign",
];

export const useSmartCampaignFeatureToggle = (accountId) => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!accountId) {
      setIsEnabled(false);
      return;
    }
    setIsLoading(true);
    const response = await FetchAccountFeatures(accountId);
    setIsLoading(false);
    if (!response || response?.error) {
      setIsEnabled(false);
      return;
    }

    const features = Array.isArray(response?.features) ? response.features : [];
    const feature = features.find((item) =>
      SMART_CAMPAIGN_FEATURE_KEYS.includes(String(item?.key || "").toLowerCase())
    );
    setIsEnabled(Boolean(feature?.enabled));
  }, [accountId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useRefreshOnAccountFeaturesUpdated(accountId, refresh);

  return { isEnabled, isLoading, refresh };
};
